import { useLoggedUserContext } from "@/contexts/LoggedUserContext";
import { useSideBarContext } from "@/contexts/SideBarContext";
import { IFeatures } from "@/utils/interfaces";
import { ExpandLess, Inbox, ExpandMore, StarBorder } from "@mui/icons-material";
import React from "react";
import {
  List,
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export function SectionSideBar({ data }: { data: any }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { sideBarItens } = useLoggedUserContext();
  const { handleExpand, expandedSections } = useSideBarContext();

  const subItens = sideBarItens
    ?.filter((e: IFeatures) => e.parent === data.text)
    ?.sort((a: any, b: any) => a?.sideMenuIndex - b?.sideMenuIndex);

  const activeGroup = subItens?.some(
    (subItemBar: IFeatures) =>
      subItemBar?.path === pathname && subItemBar?.parent === data.text
  );

  return (
    <>
      <ListItemButton
        sx={{
          backgroundColor: activeGroup && "neutral200.main",
          "&:hover": {
            backgroundColor: activeGroup && "neutral300.main",
          },
          p: 1,
          borderRadius: "8px",
        }}
        selected={data.path === pathname}
        onClick={(event) => {
          handleExpand(data.text, expandedSections?.[data.text] || false);
          navigate(data.path);
        }}
      >
        <ListItemIcon
          onClick={(event) => {
            handleExpand(data.text, expandedSections?.[data.text] || false);
          }}
        >
          {React.createElement(data.icon)}
        </ListItemIcon>
        <ListItemText primary={data.text} />
        {expandedSections?.[data.text] ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      {expandedSections?.[data.text] && (
        <Collapse
          in={expandedSections?.[data.text]}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {subItens?.map((el: IFeatures, index: number) => (
              <ListItemButton
                sx={{ p: 1, pl: 4, borderRadius: "8px" }}
                onClick={() => navigate(el.path)}
                selected={el.path === pathname}
              >
                <ListItemIcon>{React.createElement(el.icon)}</ListItemIcon>
                <ListItemText primary={el.text} />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}
